const url = process.env.REACT_APP_API_URL + "/api/energy_mix";
export default {
  list: ({ projectId }) => `${url}/?project_id=${projectId}`,
};
